import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { TranslateModule } from "@ngx-translate/core";
import { DownloadProgressComponent } from "./download-progress.component";

@NgModule({
    declarations: [DownloadProgressComponent],
    exports: [DownloadProgressComponent],
    imports: [CommonModule, MatProgressBarModule, TranslateModule, MatButtonModule]
})
export class DownloadProgressModule {}
